<template>
  <div id="contenedor-agregar-obra-basica">
    <v-row>
      <template
        v-if="!desdeContrato">
        <custom-select
          v-model="obra.ejercicio"
          cols="12"
          md="2"
          label="Ejercicio"
          :items="itemsejercicio"
          :rules="[mixReglas.requerido]"
          required>
        </custom-select>
        <custom-text-field
          v-model="obra.clave"
          cols="12"
          md="3"
          label="Clave"
          :rules="[mixReglas.requerido]"
          required>
        </custom-text-field>
        <custom-text-area
          v-model="obra.meta"
          cols="12"
          md="12"
          label="Meta"
          :rules="[mixReglas.requerido]"
          auto-grow
          required>
        </custom-text-area>
      </template>
      <custom-select
        v-model="obra.idTipo"
        cols="12"
        md="6"
        label="Tipo de Obra"
        :items="tiposObras"
        :rules="[mixReglas.requerido]"
        item-text="descripcion"
        item-value="id"
        required>
      </custom-select>
      <custom-select
        v-model="obra.idSubtipo"
        cols="12"
        md="6"
        label="SubTipo de Obra"
        :items="getSubTipoObraPorTipo"
        item-text="descripcion"
        item-value="id"
        :rules="[mixReglas.requerido]"
        required>
      </custom-select>
      <!-- <custom-select
        v-model="obra.idPrograma"
        cols="12"
        md="3"
        label="Programa"
        :items="programasInversiones"
        :rules="[mixReglas.requerido]"
        item-text="nombre"
        item-value="id"
        required>
      </custom-select>
      <custom-select
        v-model="obra.ubicacion.idMunicipio"
        cols="12"
        md="3"
        label="Municipio"
        :items="municipios"
        :rules="[mixReglas.requerido]"
        item-text="nombre"
        item-value="id"
        required>
      </custom-select>
      <custom-text-area
        v-model="obra.ubicacion.localidad"
        cols="12"
        md="6"
        label="Localidad"
        :rules="[mixReglas.requerido]"
        auto-grow
        rows="3"
        required>
      </custom-text-area>
      <custom-text-area
        v-model="obra.ubicacion.ubicacion"
        cols="12"
        md="6"
        label="Ubicación"
        :rules="[mixReglas.requerido]"
        auto-grow
        rows="3"
        required>
      </custom-text-area> -->
    </v-row>
  </div>
</template>

<script>
import mixObras from '../mixObras';
import CustomTextField from '@/components/inputs/TextField.vue';
import CustomSelect from '@/components/inputs/Select.vue';
import CustomTextArea from '@/components/inputs/TextArea.vue';

export default {
  name: 'AgregarObraBasico',
  props: {
    obra: {
      type: Object,
      required: true,
    },
    desdeContrato: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  mixins: [mixObras],
  components: {
    CustomTextField,
    CustomTextArea,
    CustomSelect,
  },
  data() {
    return {
      itemsejercicio: [2021, 2022, 2023],
    };
  },
};
</script>

<style lang="scss">

</style>
